var lastDayOfMonth = function (date) {
    return +moment(date).endOf('month').toISOString().substr(8, 2)
}

angular.module('SpidApp')

.factory('MonthStockChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var MonthStockChartGenerator = function (stockflows, when) {
        stockflows = stockflows || []
        
        var stockflowsOrderedByDay = _.chain(stockflows).groupBy(function (stockflow) {
            return moment(stockflow.updated_at).format('DD/MM/YYYY') // TODO: bad locale flow
        }).mapObject(function (stockflows) {
            var res = 0
            
            if (stockflows.length > 0) {
                res = stockflows[0].current
            }
            
            return res
        }).value()
        
        var labels = []
        var values = []
        
        var today = moment(when)
        var endOfMonth = moment(when)
        endOfMonth.set('date', lastDayOfMonth(today))
        var curseur = moment(endOfMonth)
        var nDays = lastDayOfMonth(today)
        
        for(var i = 0 ; i < nDays ; i++) {
            var key = curseur.format('DD/MM/YYYY')
            
            labels.push(key)
            values[i] = stockflowsOrderedByDay[key] || 0
            
            curseur.subtract(1, 'day')
        }
        labels = labels.reverse()
        values = values.reverse()
        
        for(i = 1 ; i <= nDays ; i++) {
            labels[i-1] = i + ''
        }
        
        this.series = ['Flux du produit']
        this.labels = labels
        this.data = [ StockChartUtils.cumulativeDistribution( values ) ]
        this.options = {
              animation            : true
            , showTooltips         : true
            , showScale            : true
            , scaleBeginAtZero     : true
            , showGridLines        : false
        }
        this.colours = [{
              fillColor   : '#FFE7A0'
            , strokeColor : '#FFC928'
        }]
    }
    
    MonthStockChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , data       : this.data
            , options    : this.options
            , colours    : this.colours
        }
    }
    
    return MonthStockChartGenerator
}])
